import { orderActionTypes } from '../order-action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { getFormattedReportFormFields } from '../../../constants/reports/report-form';
import { getFormattedDate } from '../../../utils/utilities';
import { errorHandler } from '../../../utils/newApplicationUtils';
import * as React from 'react';
import { IOrderAction } from '../order-interfaces';

export const fetchReportTypesList = async (dispatch: React.Dispatch<IOrderAction>): Promise<void> => {
	dispatch({ type: orderActionTypes.START_REPORT_LIST_LOADING });
	try {
		const res = await axios.get(`${BASE_URL.ACTIVITY}/reporting/reportTypes`);
		let reports = [];
		if (res?.data) {
			reports =Object.entries(res.data || {})?.map(el => ({
				value: el[0],
				label: el[1]
			}));
		}
		dispatch({ type: orderActionTypes.FETCH_REPORT_TYPES_LIST, payload: reports });
	} catch (e) {
		console.log(e);
		dispatch({ type: orderActionTypes.FETCH_ACTIVITY_LISTS_FAIL });
	}
};

export const setReport = async (
	dispatch: React.Dispatch<IOrderAction>,
	formik: any,
	successModalOpen: (text: string) => void
): Promise<void> => {
	try {
		dispatch({ type: orderActionTypes.START_LOADING });
		formik.handleSubmit();
		if (formik.values.reportType) {
			const data = getFormattedReportFormFields(formik.values);
			const from = data.from ? getFormattedDate(data.from, 'yyyy-MM-dd') : '';
			const to = data.to ? getFormattedDate(data.to, 'yyyy-MM-dd') : '';

			const res = await axios(`${BASE_URL.ACTIVITY}/reporting?reportId=${data.reportId}&mid=${data.mid}&from=${from}&to=${to}`);

			if (res?.data?.result) {
				successModalOpen(res.data.result);
			}
		}
		dispatch({ type: orderActionTypes.END_LOADING });

	} catch (e) {
		console.log(e);
		errorHandler({ e, formik });
		dispatch({ type: orderActionTypes.FETCH_ACTIVITY_LISTS_FAIL });
	}
};
